exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".responsive-navbar-container{display:flex;width:100%;flex-direction:row;background-color:#fff;min-width:200px;color:#67707c}.responsive-navbar-container .responsive-navbar-item{display:flex;flex:0 0 auto;align-items:center;border:none;background-color:transparent;outline:none}.responsive-navbar-container .responsive-navbar-item:focus{box-shadow:none;outline:none}.responsive-navbar-container .no-item-border{border-bottom:2px solid transparent}.responsive-navbar-container .inactive-border{border-bottom:2px solid #d3dade}.responsive-navbar-container .selected-border{box-shadow:none;border-bottom:2px solid #ec6608}.responsive-navbar-container .responsive-navbar-item-text{overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis;margin:0 5px}.responsive-navbar-container .responsive-navbar-select{font-weight:inherit;font-size:inherit;height:inherit;display:flex;flex-direction:column;align-content:center;justify-content:center;margin:0;min-width:200px;max-width:300px}.responsive-navbar-container .responsive-navbar-select .selected-border{border-bottom:2px solid #ec6608}.responsive-navbar-container .responsive-navbar-container-left{padding-left:1rem;margin-right:auto}.responsive-navbar-container .responsive-navbar-container-right{margin-left:auto}", ""]);

// exports
exports.locals = {
	"colorPrimaryOrange": "#EC6608",
	"colorPrimaryYellow": "#FECA1D",
	"colorPrimarAzure": "#67707c",
	"colorBackgroundAside": "#EAEFF3",
	"colorBackgroundMenu": "#3C4A55",
	"colorMain": "#EC6608",
	"colorBlack": "#000000",
	"colorPetrol": "#006070",
	"colorDarkSteel": "#3B4A56",
	"colorSupportGray": "#CCCCCC",
	"colorLightGray": "#D3DADE",
	"colorAttentionRed": "#DD2515",
	"colorAttentionGreen": "#3AA57B",
	"colorYellow": "#FECA1D",
	"colorOrange": "#E66608",
	"colorGreen": "#3AA57B",
	"colorAzure": "#67707C",
	"colorGray": "#CCCCCC",
	"colorRed": "#D82515",
	"colorBlue": "#16AED6",
	"colorViolet": "#943BA3",
	"colorWhite": "#FFFFFF",
	"colorText": "#67707c",
	"colorTextLink": "#EC6608",
	"colorTextDisabled": "#a7a7a7",
	"colorWarning": "#FECA1D",
	"colorSuccess": "#3AA57B",
	"colorError": "#D82515",
	"colorInfo": "#16AED6",
	"colorTooltipText": "#FFFFFF",
	"colorTooltipBackground": "#006070",
	"colorToastText": "#000000",
	"colorToastBackground": "#eaeaea",
	"colorPseudoNormal": "#67707c",
	"colorPseudoFocused": "#FECA1D",
	"colorPseudoHover": "#FECA1D",
	"colorPseudoPressed": "#FECA1D",
	"colorPseudoDisabled": "#a7a7a7",
	"colorContentBackground": "#FFFFFF",
	"colorSiteBackground": "#D3DADE",
	"colorButtonText": "#FFFFFF",
	"colorButtonTextDisabled": "#a7a7a7",
	"colorButtonNormal": "#67707c",
	"colorButtonFocused": "#67707c",
	"colorButtonHover": "#77818c",
	"colorButtonPressed": "#585F68",
	"colorButtonPriorityNormal": "#E66608",
	"colorButtonPriorityFocused": "#E66608",
	"colorButtonPriorityHover": "#ff7517",
	"colorButtonPriorityPressed": "#d35c0b",
	"colorButtonDisabled": "#f0f0f0",
	"colorDatePickerContent": "#E9E9E9",
	"colorSelectHover": "#eff2f4",
	"colorSelectSelected": "#e6e9eb",
	"colorGridText": "#67707c",
	"colorGridBorder": "#D3DADE",
	"colorGridBackground": "#FFFFFF",
	"colorGridStripe": "#D3DADE",
	"colorGridHighlight": "#eff2f4",
	"colorGridSelected": "#e6e9eb",
	"borderRadiusBase": "0",
	"borderRadiusLarge": "0",
	"borderRadiusSmall": "0",
	"heightNavbar": "40px",
	"spaceContent": "1rem",
	"radiusContent": "0.5rem",
	"radiusNavbar": "0",
	"sidemenuColorText": "#FFFFFF",
	"fontWeightLight": "300",
	"fontWeightNormal": "400",
	"fontWeightBold": "700",
	"fontSizeH1": "3.6rem",
	"fontSizeH2": "3rem",
	"fontSizeH3": "2.4rem",
	"fontSizeH4": "1.8rem",
	"fontSizeLarge": "1.8rem",
	"fontSizeMedium": "1.6rem",
	"fontSizeNormal": "1.4rem",
	"fontSizeSmall": "1.2rem",
	"marginContent": "10px"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader/lib??ref--2-2!../node_modules/sass-loader/lib/loader.js!./responsive-navbar.scss
// module id = 184
// module chunks = 0